// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"58e43cca","703":"b97a1b7e","787":"ed151cb5"}[chunkId] + ".chunk.js";
};